/**
 * @file order-details.component.ts
 */
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MailOrder } from '../../interfaces/mail-order.interface';
import { PrescriptionFill } from '../../interfaces/prescription-fill.interface';
import { MailOrderStatus } from '../../enums/enum';
import { MultilingualService } from '../../core/services/multilingual/multilingual.service';
import { AppInsightsService } from '../../services/app-insights/app-insights.service';
import { AppCenterAnalytics } from '../../services/app-insights/app-insights';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: []
})
export class OrderDetailsComponent implements OnInit {
  public stepNo = 0;
  public mailOrderStatus = MailOrderStatus;

  constructor(
    public readonly multilingualService: MultilingualService,
    private readonly appInsightsService: AppInsightsService,
    private readonly userService: UserService,
    @Inject(MAT_DIALOG_DATA) public order: MailOrder<PrescriptionFill>
  ) {
    let check: { [key: string]: number };
    if (this.userService.isOrionUser()) {

      if (this.order.orderStatus === this.mailOrderStatus.CANCELLED) {
        // for cancelled order, the steps will be In-Progress and Cancelled
        check = {
          [this.mailOrderStatus.IN_PROGRESS]: 1,
          [this.mailOrderStatus.CANCELLED]: 2,
        };
      } if (this.order.orderStatus === this.mailOrderStatus.PICKED_UP) {
        // for picked up order, the steps will be In-Progress and Picked Up
        check = {
          [this.mailOrderStatus.IN_PROGRESS]: 1,
          [this.mailOrderStatus.PICKED_UP]: 2,
        };
      } else {
        // for other orders, the steps will be In-Progress and Shipped
        check = {
          [this.mailOrderStatus.IN_PROGRESS]: 1,
          [this.mailOrderStatus.SHIPPED]: 2,
        };
      }
      this.stepNo = check[this.order.orderStatus];
      if (!this.stepNo) {
        this.stepNo = 1; // first step is for 'in-progress'
      }
    } else {
      check = {
        [this.mailOrderStatus.WAITING_FOR_PAYMENT]: 1,
        [this.mailOrderStatus.SHIPPED]: 3,
        [this.mailOrderStatus.PICKED_UP]: 3,
      };

      this.stepNo = check[this.order.orderStatus];
      if (!this.stepNo) {
        this.stepNo = 2; // 2nd step is for 'in-progress'
      }
    }
  }

  public showShipmentDetails() {
    return this.order.orderStatus === this.mailOrderStatus.SHIPPED || this.order.orderStatus === this.mailOrderStatus.PICKED_UP;
  }

  ngOnInit(): void {
    this.appInsightsService.trackPageView(AppCenterAnalytics.ORDERS_DETAILS_VIEWED);
  }

}
